import { merge } from 'lodash-es';

import { SpacingProps } from '../../styles/getSpacingSprinkles.js';
import { spacingToCss } from '../helpers/spacingToCss.js';
import type { MarginCSS, DefaultMargin } from '../types/layout.types.js';

const defaultMargin: DefaultMargin = {
  margin: 0,
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
};

/**
 * Generates CSS margin properties based on the provided margin props and default margin values.
 * @internal
 */
export const useMarginProps = (
  props: SpacingProps,
  defaultMarginProps: DefaultMargin = defaultMargin,
): MarginCSS => {
  const {
    margin,
    m,
    marginX,
    mx,
    marginY,
    my,
    marginTop,
    mt,
    marginRight,
    mr,
    marginBottom,
    mb,
    marginLeft,
    ml,
  } = props;

  const convertedDefaultMarginProps = {
    marginTop: spacingToCss(
      defaultMarginProps.marginTop ?? defaultMarginProps.margin,
    ),
    marginLeft: spacingToCss(
      defaultMarginProps.marginLeft ?? defaultMarginProps.margin,
    ),
    marginBottom: spacingToCss(
      defaultMarginProps.marginBottom ?? defaultMarginProps.margin,
    ),
    marginRight: spacingToCss(
      defaultMarginProps.marginRight ?? defaultMarginProps.margin,
    ),
  };

  return merge({}, convertedDefaultMarginProps, {
    marginTop: spacingToCss(mt ?? marginTop ?? my ?? marginY ?? m ?? margin),
    marginRight: spacingToCss(
      mr ?? marginRight ?? mx ?? marginX ?? m ?? margin,
    ),
    marginBottom: spacingToCss(
      mb ?? marginBottom ?? my ?? marginY ?? m ?? margin,
    ),
    marginLeft: spacingToCss(ml ?? marginLeft ?? mx ?? marginX ?? m ?? margin),
  });
};
